export default {
  id: 148,
  title: 'Target #148 - Eight',
  url: 'https://cssbattle.dev/play/148',
  colors: ['#926927', '#6D480A'],
  solution:
    '<a a><a b><style>a,body{background:#926927}a{position:fixed;width:100;height:100;border:40px solid #6d480a;border-radius:9in}[a]{top:-90;left:210;box-shadow:10px 0 #6d480a}[b]{top:10;left:310}</style>',
}
